<template
	><div style="padding-top:-2px;margin-top:-2px;">
		<v-label
			><b>{{ label }}</b></v-label
		>
		<s-select-generic
			class="text"
			itemvalue="LytID"
			:disabled="disabled"
			:value="value"
			id="LytID"
			itemtext="LytDescription"
			:return-object="returnObject"
			@input="input($event)"
			:config="config"
			:full="full"
			:text="text"
			:clearable="clearable"
			:noDefault="noDefault"
			:readonly="readonly"
		>
		</s-select-generic>
	</div>
</template>

<script>
	import _sService from "@/services/FreshProduction/PrfLayetteIncidenceService.js";
	export default {
		components: {},
		props: {
			disabled: {
				type: Boolean,
				default: false,
			},
			clearable: {
				type: Boolean,
				default: false,
			},
			value: null,
			text: { type: String, default: "" },
			label: {
				type: String,
				default: "",
			},
			returnObject: {
				type: Boolean,
				default: false,
			},
			noDefault: {
				type: Boolean,
				default: false,
			},
			full: {
				type: Boolean,
				default: false,
			},
			readonly:{ type: Boolean, default: false}
		},
		watch: {
			value(value) {
				this.item = value;
			},
		},
		methods: {
			input(val) {
				this.$emit("input", val);
			},
		},
		data: () => ({
			item: 0,
			val: "",
			items: [],
			config: {},
		}),

		created() {
			this.config = {
				url: _sService.GetUrllistLayette(),
				title: this.label,
				params: { requestID: this.$fun.getUserID() },
			};
		},
	};
</script>
